import { IApplicationState } from "..";
import ICompany from "../../models/ICompany";

export function selectCompany(state: IApplicationState): ICompany | undefined {
  return state.context.company;
}

export function selectAvailableCompanies(state: IApplicationState): Array<ICompany> {
  return state.context.companies;
}
